import { getStudiosSuggestion, getStudiosSuggestionsByIds } from '../../api/studiosApi'
import { getOptions } from '../../helpers/utils'
import translate from '../../i18n'
import { ICorporateOnlyLessonDefinitionFilterParams } from '../../pages/corporate-only-lesson-definitions-container/share-type'
import DebounceSelect from '../debounce-select/debounce-select'
import FormattedMessage from '../intl/format-message'
import { SearchOutlined } from '@ant-design/icons'
import { Button, Form } from 'antd'
import { useEffect, useState } from 'react'

interface ICorporateOnlyLessonDefinitionFilter {
  onSearch: (value: ICorporateOnlyLessonDefinitionFilterParams) => void
  formData: ICorporateOnlyLessonDefinitionFilterParams | undefined
}

const CorporateOnlyLessonDefinitionFilter = (props: ICorporateOnlyLessonDefinitionFilter) => {
  const { onSearch, formData } = props
  const [form] = Form.useForm()
  const [defaultStudioSuggestionsOptions, setStudioSuggestionsOptions] = useState<
    { label: string; value: number }[]
  >([])

  useEffect(() => {
    if (formData) {
      form.setFieldsValue(formData)
      if (formData.studioId) {
        setStudioSuggestionsOptionsAction(formData.studioId)
      }
    }
  }, [formData])

  const onFinish = (values: ICorporateOnlyLessonDefinitionFilterParams) => {
    onSearch(values)
  }

  async function fetchStudioList(keyword: string): Promise<{ label: string; value: number }[]> {
    return getStudiosSuggestion(keyword).then(res => {
      return getOptions(res)
    })
  }
  const setStudioSuggestionsOptionsAction = (studioId: number) => {
    getStudiosSuggestionsByIds([studioId]).then(res => {
      setStudioSuggestionsOptions(getOptions(res))
    })
  }

  return (
    <Form form={form} layout="inline" className="filter-inline-form" onFinish={onFinish}>
      <Form.Item name="studioId" label={translate('corporateOnlyLessonDefinitions.studioId')}>
        <DebounceSelect
          style={{ minWidth: 130 }}
          showSearch
          allowClear
          placeholder={translate('searchTrends.studio.message')}
          fetchOptions={fetchStudioList}
          defaultOptions={defaultStudioSuggestionsOptions}
        />
      </Form.Item>

      <Form.Item>
        <Button htmlType="submit" type="primary" icon={<SearchOutlined />}>
          <FormattedMessage id="search"></FormattedMessage>
        </Button>
      </Form.Item>
    </Form>
  )
}

export default CorporateOnlyLessonDefinitionFilter
